import React from 'react';
import {Lang} from "./LanguagePicker";
import {connect} from "react-redux";
class HeaderComponent extends React.Component {
    constructor(props) {
        super ( props );

        this.state = {};
    }

    render() {
        return (
            <div id={"header"}
                className={this.props.className+ " flex-between margin-20"}
                onClick={this.props.handleClick}
            >
                <img src={require("../images/logo.png")} width={'300px'} alt={"logo"}
                onClick={()=>{window.location.href = 'https://prodaja.lo.co.me'}}/>
                    <h4 style={{fontSize : "24px", fontWeight: "500"}}><img src={this.props.insuranceImage} alt={"ikonica"}/> {this.props.insuranceName}</h4>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return ({
        lang : state ? state.lang : '' ,
    });
};

export const Header = connect ( mapStateToProps ) ( HeaderComponent );